import Header from "components/Headers/Header";
import {
  Container,
  Table,
  Modal,
  ModalBody,
  Button,
  Card,
  Row,
  Col,
  ModalFooter,
} from "reactstrap";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { refundsStates } from "store/actions/additionalEarningAction";

const RefundDetails = () => {
  let dispatch = useDispatch();
  const [modal1, setModal1] = useState(false);
  const [participant, setParticipant] = useState([]);
  const location = useLocation();
  const { RefundsName } = location.state;
  const { refundsData } = useSelector((state) => state.earnings);
  useEffect(() => {
    dispatch(refundsStates());
  }, []);
  const refunds = refundsData?.[RefundsName];

  const handleButtonClick3 = (e, participants) => {
    if (participants) {
      setParticipant(participants);
    }
    setModal1(!modal1);
  };

  return (
    <>
      <Header />
      <Container fluid className="my-4">
        <Card className="p-2">
          <h2 className="px-3 mt-3">Refund Details</h2>
          <Row>
            <Col sm="12">
              <Table className="align-items-center table-flush mt-4" responsive>
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Athlete ID
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Athlete
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      View Participents
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="custom-table-body mt-3">
                  {refunds?.length > 0 ? (
                    refunds.map((items, index) => {
                      return (
                        <tr key={index}>
                          <td>{items.athleteId}</td>
                          <td>{items.athleteName}</td>
                          <td>
                            <Button
                              color="primary"
                              className="text-sl px-3 py-2"
                              onClick={(e) =>
                                handleButtonClick3(e, items.participants)
                              }
                            >
                              View
                            </Button>
                          </td>
                          <td>{items.refundAmount}$</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td>N/A</td>
                      <td>N/A</td>
                      <td>
                        <Button
                          color="primary"
                          className="text-sl px-3 py-2"
                          disabled
                        >
                          View
                        </Button>
                      </td>
                      <td>N/A</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>
      </Container>
      {refunds?.map((value, index) => (
        <Modal
          key={index}
          isOpen={modal1}
          toggle={handleButtonClick3}
          size="md"
          scrollable="true"
        >
          <ModalBody>
            <Table className="align-items-center table-flush mt-3" responsive>
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="custom-table-heading   custom-heading"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="custom-table-heading custom-heading"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="custom-table-body mt-3">
                {participant.map((items, index) => {
                  return (
                    <tr key={index}>
                      <td>{items.fan}</td>
                      <td>{items.amount}$</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              className="text-sl px-3 py-2"
              onClick={handleButtonClick3}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      ))}
    </>
  );
};

export default RefundDetails;
